import { RequestStatus } from "request";

export interface PartnersState {
  partners: Partner[];
  fetchPartnersRequestState: RequestStatus;
  totalPartnersCount: number;
}

export type Partner = {
  firstName: string;
  lastName: string;
  partnerId: number;
  mail: string;
  companyName: string;
  accountManagerNames: string;
};

export const initialState: PartnersState = {
  partners: [],
  totalPartnersCount: 0,
  fetchPartnersRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  },
};

export function Partners(state = initialState, action: any) {
  switch (action.type) {
    case "partners-update-request-state":
      return {
        ...state,
        fetchPartnersRequestState: action.requestState,
      };
    case "partners-update-state":
      return {
        ...state,
        partners: action.partners,
        totalPartnersCount: action.totalPartnersCount,
      };
    default:
      return state;
  }
}
